import cn from "clsx";
import React, { HTMLAttributes } from "react";
import { Text } from "../../text";
import styles from "../Table.module.scss";

export type TableCellProps = React.PropsWithChildren<{
    /**
     * Element tag to use for this component
     */
    tag?: "td" | "th" | "span";
    /***
     * Sets the font weight
     */
    emphasis?: "none" | "1" | "2";
}> &
    HTMLAttributes<HTMLTableCellElement>;

export const TableCell: React.FC<TableCellProps> = ({
    tag = "td",
    emphasis = "none",
    children,
    className = "",
    ...cellProps
}) => {
    return (
        <Text.Data
            variant="2"
            tag={tag}
            emphasis={emphasis}
            className={cn(styles.cell, className, {
                [styles["cell--header"]]: tag === "th",
            })}
            {...cellProps}
        >
            {children}
        </Text.Data>
    );
};
